/**
 * RESPONSIBILITY: draw a block that is one YouTube video.
 *
 * The player is the one sermons use: YouTube's own still first, the video in place on a
 * click. A link that is not a video falls through to opening in a new tab.
 */
import { ADC_THEME } from '@app/sections';
import { AdcBand } from './AdcBand';
import { VideoPlayer } from '../commons/VideoPlayer';
import { YoutubeThumb } from '../commons/YoutubeThumb';
import type { AdcBlockProps } from './kind';

export function AdcVideo({ b }: AdcBlockProps) {
  if (!b.videoHref) return null;
  return (
    <AdcBand theme={ADC_THEME.Video} heading={b.heading}>
      <VideoPlayer
        url={b.videoHref}
        title={b.heading || b.videoHref}
        className="video adc-video"
        picture={<YoutubeThumb url={b.videoHref} alt={b.heading} className="video-pic" />}
      />
    </AdcBand>
  );
}
